import { Outlet } from "react-router-dom";
import Footer from "../Sections/Footer";
import Header from "../Sections/Header";


//css files
import '../assets/css/fontiran.css'
import 'owl.carousel/dist/assets/owl.carousel.css'
import '../assets/css/animate.min.css'
import "../assets/css/all.min.css"
import '../assets/css/bootstrap.rtl.min.css'
import "../assets/css/style.css"

export default function MainLayout() {
    return(
        <>
            <Header/>
            <Outlet />
            <Footer/>
        </>
    )
}